<template>
  <a-card class="style1">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="General">
        <a-table :loading="isLoading" :columns="columns" :data-source="moderatorActivities" size="middle" bordered rowKey="id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <div slot="moderatorEmail" slot-scope="text, record">
            {{ record.user.email }}
          </div>
          <div slot="moderatorFullname" slot-scope="text, record">
            {{ getModeratorFullName(record) }}
          </div>
          <div slot="uploaderEmail" slot-scope="text, record">
            {{ record.uploader.email }}
          </div>
          <div slot="uploaderFullname" slot-scope="text, record">
            {{ getUploaderFullName(record) }}
          </div>
          <div slot="videoType" slot-scope="text, record">
            {{ record.intro_video && record.intro_video.video_type === 'welcome' ? 'Invitation' : 'Jesus Story' }}
          </div>
          <div slot="videoUrl" slot-scope="text, record">
            {{ (record.intro_video && record.intro_video.video_url) || '' }}
          </div>
          <div slot="moderatorAction" slot-scope="text, record">
            {{ moderatorActions[record.moderator_action] }}
          </div>
          <div slot="created_at" slot-scope="text, record">
            {{ getCreatedAt(record) }}
          </div>
          <div slot="action" slot-scope="record" class="action">
            <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
              <a href="javascript:;">Delete</a>
            </a-popconfirm>
          </div>
          <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
            <a-input
              v-ant-ref="c => (searchInput = c)"
              :placeholder="`Search ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 190px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
            />
            <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
            <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
          </div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Moderators by Activity">
        <div style="text-align: right; margin: 16px 0;">
          <a-select :default-value="moderatorFilter" style="width: 160px;" @change="handleActivityChange">
            <a-select-option value="approved">
              Approved
            </a-select-option>
            <a-select-option value="notsure">
              Not Sure
            </a-select-option>
            <a-select-option value="banned">
              Banned
            </a-select-option>
            <a-select-option value="blocked">
              Blocked
            </a-select-option>
          </a-select>
        </div>
        <a-table :loading="isLoading" :columns="columns2" :data-source="rankedModerators" size="middle" bordered rowKey="user_id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <div slot="moderatorEmail" slot-scope="text, record">
            {{ record.user.email }}
          </div>
          <div slot="moderatorFullname" slot-scope="text, record">
            {{ getModeratorFullName(record) }}
          </div>
          <div slot="uploaderEmail" slot-scope="text, record">
            {{ record.uploader.email }}
          </div>
          <div slot="uploaderFullname" slot-scope="text, record">
            {{ getUploaderFullName(record) }}
          </div>
          <div slot="moderatorAction" class="text-capitalize">
            {{ moderatorFilter }}
          </div>
          <div slot="action" slot-scope="record" class="action">
            <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
              <a href="javascript:;">Delete</a>
            </a-popconfirm>
          </div>
          <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
            <a-input
              v-ant-ref="c => (searchInput = c)"
              :placeholder="`Search ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 190px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
            />
            <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
            <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
          </div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import { includes, replace, map } from 'lodash';
import moment from 'moment';
import AdminService from '@/services/AdminService';
export default {
  data() {
    const roleInfo = [
      { text: 'Admin', value: 'admin' },
      { text: 'Care', value: 'care' },
      { text: 'Disciple', value: 'disciple' },
      { text: 'Evangelism', value: 'evangelism' },
      { text: 'Individual', value: 'individual' },
    ];

    const moderatorLevel = [
      { text: 'Moderator 1', value: 'level_1' },
      { text: 'Moderator 2', value: 'level_2' },
    ];

    const moderatorStatus = [
      { text: 'Under review', value: 'review' },
      { text: 'Approve', value: 'approved' },
      { text: 'Decline', value: 'declined' },
    ];

    const moderatorActions = {
      approved: 'Approved',
      notsure: 'Not Sure',
      blocked: 'Blocked',
      banned: 'Banned',
    };

    const columns = [
      {
        title: 'Moderator Email',
        dataIndex: 'moderatorEmail',
        key: 'moderatorEmail',
        scopedSlots: {
          customRender: 'moderatorEmail',
        },
        onFilter: (value, record) => includes(record.user.email, value),
      },
      {
        title: 'Moderator Name',
        dataIndex: 'moderatorFullname',
        key: 'moderatorFullname',
        scopedSlots: {
          customRender: 'moderatorFullname',
        },
      },
      {
        title: 'Uploader Email',
        dataIndex: 'uploaderEmail',
        key: 'uploaderEmail',
        scopedSlots: {
          customRender: 'uploaderEmail',
        },
        onFilter: (value, record) => includes(record.uploader.email, value),
      },
      {
        title: 'Uploader Name',
        dataIndex: 'uploaderFullname',
        key: 'uploaderFullname',
        scopedSlots: {
          customRender: 'uploaderFullname',
        },
      },
      {
        title: 'Video Type',
        dataIndex: 'videoType',
        key: 'videoType',
        scopedSlots: {
          customRender: 'videoType',
        },
      },
      {
        title: 'Video Url',
        dataIndex: 'videoUrl',
        key: 'videoUrl',
        scopedSlots: {
          customRender: 'videoUrl',
        },
      },
      {
        title: 'Action',
        dataIndex: 'moderator_action',
        key: 'moderator_action',
        scopedSlots: {
          customRender: 'moderatorAction',
        },
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
      },
      {
        title: 'Created at',
        dataIndex: 'created_at',
        key: 'created_at',
        scopedSlots: {
          customRender: 'created_at',
        },
      },
    ].map(item => {
      if (!['operation', 'role', 'status', 'level'].includes(item.key)) {
        return {
          ...item,
          scopedSlots: {
            ...item.scopedSlots,
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          onFilter: (value, record) => {
            switch (this.searchedColumn) {
              case 'moderatorEmail':
                return record.user && includes(slugData(record.user.email), slugData(value));
              case 'moderatorFullname':
                return record.user && includes(slugData(`${record.user.firstname} ${record.user.firstname}`), slugData(value));
              case 'uploaderEmail':
                return record.uploader && includes(slugData(record.uploader.email), slugData(value));
              case 'uploaderFullname':
                return record.uploader && includes(slugData(`${record.uploader.firstname} ${record.uploader.firstname}`), slugData(value));
              default:
                return record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value));
            }
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        };
      }
      return item;
    });
    return {
      form: this.$form.createForm(this),
      moderatorList: [],
      searching: '',
      error: '',
      isLoading: true,
      moderatorActivities: [],
      rankedModerators: [],
      moderatorFilter: 'banned',
      moderatorLevel,
      moderatorStatus,
      moderatorActions,
      roleInfo: map(roleInfo, item => ({ label: item.text, value: item.value })),
      columns: columns.filter(c => c.key !== 'total'),
      columns2: columns.filter(c => !['uploaderEmail', 'uploaderFullname', 'videoType', 'videoUrl', 'created_at'].includes(c.key)),
    };
  },
  watch: {
    moderatorList: {
      async handler(val) {
        this.moderatorActivities = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    empty,
    getRoleInfo(text) {
      text = replace(text, '[', '');
      text = replace(text, ']', '');
      return text;
    },
    getModeratorFullName(record) {
      const { firstname, lastname } = record.user;
      return `${firstname || ''} ${lastname || ''}`.trimLeft();
    },
    getUploaderFullName(record) {
      const { firstname, lastname } = record.uploader;
      return `${firstname || ''} ${lastname || ''}`.trimLeft();
    },
    getCreatedAt(record) {
      const date = new Date(record.created_at || Date.now());
      return moment(date).format('MM/DD/YYYY');
    },
    async doInitData() {
      this.moderatorList = await AdminService.moderator.getActivities();
      this.rankedModerators = await AdminService.moderator.getActivities(this.moderatorFilter);
    },
    async handleActivityChange(value) {
      this.moderatorFilter = value;

      this.isLoading = true;

      try {
        this.rankedModerators = await AdminService.moderator.getActivities(this.moderatorFilter);
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    handleCancel() {},
    async handleLevelChange(value, record) {
      this.isLoading = true;

      const { id } = record.moderator;

      await AdminService.moderator.update(id, {
        level: value,
      });
      this.isLoading = false;
    },
    async handleStatusChange(value, record) {
      this.isLoading = true;

      const { id, status } = record.moderator;

      await AdminService.moderator.update(id, {
        status: value,
      });

      const element = document.querySelector(`.select-status-${id}`);
      element.classList.remove(`select-value-${status}`);
      element.classList.add(`select-value-${value}`);

      this.isLoading = false;
    },
    handleReset(clearFilters) {
      clearFilters();
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.moderator.delete(record.moderator.id);

        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.firstname} ${record.lastname} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },
  },
};
</script>
<style lang="scss">
.select-value-review,
.select-option-review {
  color: #33cacc;
}
.select-value-approved,
.select-option-approved {
  color: #78beff;
}
.select-value-declined,
.select-option-declined {
  color: #eb685f;
}
</style>
